import React from "react";
import "./FeedbackModal.css";

export default function FeedbackModal({
  open,
  feedbackText,
  setFeedbackText,
  feedbackType,
  setFeedbackType,
  onClose,
  onSubmit
}) {
  if (!open) return null;

  return (
    <div
      className="aa-modal-backdrop"
      onClick={onClose}
    >
      <div
        className="aa-modal feedback-modal"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="feedback-header">
          <h3>Share Feedback</h3>

          <button
            className="feedback-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <p className="feedback-subtitle">
          Help us improve Agni Tutor by sharing your suggestions,
          issues, or feature requests.
        </p>

        <select
          className="feedback-select"
          value={feedbackType}
          onChange={(e) => setFeedbackType(e.target.value)}
        >
          <option value="">
            Select Category
          </option>

          <option value="bug">
            🐞 Bug Report
          </option>

          <option value="feature">
            ✨ Feature Request
          </option>

          <option value="improvement">
            🚀 Improvement Suggestion
          </option>

          <option value="general">
            💬 General Feedback
          </option>
        </select>

        <textarea
          className="feedback-textarea"
          rows={6}
          placeholder="Describe your experience with Agni Tutor..."
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
        />

        <div className="feedback-footer">

          <button
            className="feedback-cancel"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="feedback-submit"
            onClick={onSubmit}
            disabled={!feedbackText.trim()}
          >
            Submit Feedback
          </button>

        </div>

      </div>
    </div>
  );
}